import { MyChannelButton } from './MyChannelButton';
import { ChannelSearchBox } from './ChannelSearchBox';

// Static sub-bar for the channels tab: quick access to the user's own
// channel(s) on the left, and a (for now inert) channel search box on the
// right. It sits below the header's gold line, on the content background, and
// stays fixed above the feed.
export const ChannelsHeaderActions = () => {
  return (
    <div
      className="flex items-center justify-between gap-2 border-b border-gray-200 bg-white py-2.5 shadow-sm dark:border-gray-800 dark:bg-gray-900"
      style={{ paddingLeft: '24px', paddingRight: '24px' }}
    >
      <MyChannelButton />
      <div className="w-1/2">
        <ChannelSearchBox />
      </div>
    </div>
  );
};
